import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';

@Component({
  selector: 'app-mars',
  templateUrl: './mars.component.html',
  styleUrls: ['./mars.component.scss']
})
export class MarsComponent implements OnInit {
  constructor(private formService: FormService) { }

  marsIncidentForm: FormGroup = this.formService.marsIncidentForm

  ngOnInit(): void {
  }

}
